/* eslint-disable max-len */
export const REGEXP_TEMPLATE_FILE_NAME: RegExp = /([^/]+?$)/g;
export const REGEXP_TEMPLATE_ALL_NON_FLOAT_SYMBOLS: RegExp = /[^0-9.-]+/g;
export const REGEXP_TEMPLATE_ALL_NON_INTEGER_SYMBOLS: RegExp = /[^0-9-]+/g;
export const REGEXP_TEMPLATE_ALL_NUMBER_SYMBOLS: RegExp = /[0-9]+/g;
export const REGEXP_TEMPLATE_ALL_NAME_SYMBOLS: RegExp = /[a-zA-Z0-9._-]+/g;
export const REGEXP_TEMPLATE_COMMA_SEPARATED_NUMBER: RegExp = /\B(?=(\d{3})+(?!\d))/g;
export const REGEXP_TEMPLATE_PASSWORD: RegExp = /^(?=.*?[A-Z])(?=.*?[a-z])((?=.*?[0-9])|(?=.*?[#?!@$%^&*-])).{8,}$/;
export const REGEXP_TEMPLATE_EMAIL: RegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const REGEXP_TEMPLATE_LINK_PATTERN: RegExp = /({{ link-\d+ }})/g;
export const REGEXP_TEMPLATE_MULTIPLE_DOTS: RegExp = /\\.{2,}/g;
export const REGEXP_TEMPLATE_MULTIPLE_MINUSES: RegExp = /-+/g;
export const REGEXP_TEMPLATE_MULTIPLE_DOTS_AND_COMMAS: RegExp = /[.,]/g;
export const REGEXP_TEMPLATE_CAMEL_CASE: RegExp = /([a-z0-9])([A-Z])/g;
export const REGEXP_TEMPLATE_HAS_DOT: RegExp = /[.]/;
export const REGEXP_TEMPLATE_FILE_EXTENSION: RegExp = /[^.]+$/;
export const REGEXP_TEMPLATE_CLEAR_FILE_NAME: RegExp = /\.[^/.]+$/g;
export const REGEXP_TEMPLATE_HAS_LOWERCASE: RegExp = /[a-z]/;
export const REGEXP_TEMPLATE_HAS_UPPERCASE: RegExp = /[A-Z]/;
export const REGEXP_TEMPLATE_HAS_NUMBERS: RegExp = /[0-9]/;
export const REGEXP_TEMPLATE_HAS_SPECIAL_CHARACTERS: RegExp = /[-!$%^&*()_+|~=`{}[\]:/;<>?,.@#]/;
export const REGEXP_TEMPLATE_LINK: RegExp = /(https?:\/\/\S+)/ig;
export const REGEXP_TEMPLATE_DOMAIN: RegExp = /^[a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/;
export const REGEXP_TEMPLATE_SUBDOMAIN: RegExp = /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}$/;
export const REGEXP_TEMPLATE_MENTION_HTML_ANCHORS: RegExp = /<a class="mention" .*>(.*)<\/a>/gi;
export const REGEXP_TEMPLATE_HASHTAG_HTML_ANCHORS: RegExp = /<a class="hashtag" .*>(.*)<\/a>/gi;
export const REGEXP_TEMPLATE_ZERO_COUNTRY_CODE: RegExp = /^\+0/g;
export const REGEXP_TEMPLATE_FORM_BRACKET_NUMBERS: RegExp = /\[(-?\d+)\]/g;
